import $ from 'jquery';
import { onPageLoad } from '@/js/modules/page_load';

onPageLoad(() => {
  const mergeVendorsCounter = document.querySelector('.merge-vendors-counter');
  const mergeCheckboxesSelector = 'input[type=checkbox].merge-vendors';

  if (mergeVendorsCounter) {
    const updatePaginationLinks = () => {
      document
        .querySelector('.pagination')
        .querySelectorAll('a')
        .forEach((link) => {
          const url = new URL(window.location);
          const params = url.searchParams;
          const mergeVendorIds = params.getAll('vendor_ids_to_merge[]');
          const hrefParams = new URLSearchParams(link.href.split('?')[1]);

          hrefParams.delete('vendor_ids_to_merge[]');
          mergeVendorIds.forEach((vendorId) => {
            hrefParams.append('vendor_ids_to_merge[]', vendorId);
          });
          link.href = new URL(link.href.split('?')[0]).pathname + '?' + hrefParams.toString();
        });
    };

    const mergeButton = mergeVendorsCounter.closest('a');
    const updateMergeCounter = () => {
      const newCounter = parseInt(mergeVendorsCounter.dataset.counter);

      if (newCounter === 0) {
        mergeVendorsCounter.textContent = 'Merge';
      } else {
        mergeVendorsCounter.textContent = `Merge (${newCounter})`;
      }

      if (newCounter > 1 && mergeButton.classList.contains('button-disabled')) {
        mergeButton.classList.remove('button-disabled');
      }

      if (newCounter < 2) {
        mergeButton.classList.add('button-disabled');
      }
    };

    const setVendorIdsToMergeParam = (newVendorIdsToMerge, currentParams, currentUrl) => {
      currentParams.delete('vendor_ids_to_merge[]');
      newVendorIdsToMerge.forEach((vendorId) => {
        currentParams.append('vendor_ids_to_merge[]', vendorId);
      });

      window.history.replaceState({}, '', currentUrl);
      window.dispatchEvent(new Event('vendorIdsToMergeChanged'));

      if (document.querySelector('.pagination')) {
        updatePaginationLinks();
      }
    };

    window.addEventListener('vendorIdsToMergeChanged', () => {
      const mergeButtonUrl = new URL(mergeButton.href);
      const mergeButtonParams = mergeButtonUrl.searchParams;
      mergeButtonParams.delete('vendor_ids[]');

      mergeVendorsCounter.dataset.counter = 0;
      new URL(window.location.href).searchParams
        .getAll('vendor_ids_to_merge[]')
        .forEach((vendorId) => {
          mergeButtonParams.append('vendor_ids[]', vendorId);
          mergeVendorsCounter.dataset.counter = parseInt(mergeVendorsCounter.dataset.counter) + 1;
        });

      mergeButton.href = mergeButtonUrl.toString();
      updateMergeCounter();
    });

    $(document).on('change', 'input[type=radio].selected-target-vendor', (e) => {
      const mergeVendorsProfilesButton = document.querySelector('.p-button--merge-vendors-form');

      if (e.target.checked) {
        mergeVendorsProfilesButton.classList.remove('button-disabled');
      }
    });

    $(document).on($.modal.CLOSE, '.modal--merge-vendors-form', (e) => {
      $(e.target).remove();
    });

    document.querySelectorAll('.status-badge--duplicated').forEach((duplicatedFlag) => {
      const tbody = duplicatedFlag.closest('tbody');
      const vendorRows = tbody.querySelectorAll('tr');

      duplicatedFlag.addEventListener('click', () => {
        const currentUrl = new URL(window.location);
        const currentParams = currentUrl.searchParams;
        const similarIds = JSON.parse(duplicatedFlag.dataset.similarIds);
        const currentVendorIds = currentParams
          .getAll('vendor_ids_to_merge[]')
          .map((vendorId) => parseInt(vendorId));

        if (duplicatedFlag.dataset.selectedGroupId) {
          const selectedGroupUUID = duplicatedFlag.dataset.selectedGroupId;
          document
            .querySelectorAll(
              `${mergeCheckboxesSelector}[data-selected-group-id="${selectedGroupUUID}"]`
            )
            .forEach((mergeCheckbox) => {
              mergeCheckbox.checked = false;
              mergeCheckbox.dispatchEvent(new Event('change', { bubbles: true }));
              mergeCheckbox.removeAttribute('data-selected-group-id');
            });

          const newVendorsIds = currentVendorIds.filter(
            (vendorId) => !similarIds.includes(vendorId)
          );
          setVendorIdsToMergeParam(newVendorsIds, currentParams, currentUrl);

          document.querySelectorAll('.status-badge--duplicated').forEach((flag) => {
            flag.removeAttribute('data-selected-group-id');
          });
        } else if (
          currentVendorIds.length > 0 &&
          similarIds.every((vendorId) => currentVendorIds.includes(vendorId))
        ) {
          document.querySelectorAll(mergeCheckboxesSelector).forEach((mergeCheckbox) => {
            if (similarIds.includes(parseInt(mergeCheckbox.dataset.vendorId))) {
              mergeCheckbox.checked = false;
              mergeCheckbox.dispatchEvent(new Event('change', { bubbles: true }));
            }
          });

          const newVendorsIds = currentVendorIds.filter(
            (vendorId) => !similarIds.includes(vendorId)
          );
          setVendorIdsToMergeParam(newVendorsIds, currentParams, currentUrl);
        } else {
          const uuid = crypto.randomUUID();

          const similarVendors = Array.from(vendorRows).filter((vendorRow) => {
            const mergeCheckbox = vendorRow.querySelector(mergeCheckboxesSelector);
            const vendorId = parseInt(mergeCheckbox.dataset.vendorId);

            return similarIds.includes(vendorId);
          });

          vendorRows.forEach((vendorRow) => {
            const mergeCheckbox = vendorRow.querySelector(mergeCheckboxesSelector);
            if (!vendorRow.contains(duplicatedFlag) && mergeCheckbox.checked) {
              mergeCheckbox.checked = false;
              mergeCheckbox.dispatchEvent(new Event('change', { bubbles: true }));
              mergeCheckbox.removeAttribute('data-selected-group-id');
            }
          });

          document.querySelectorAll('.status-badge--duplicated').forEach((flag) => {
            flag.removeAttribute('data-selected-group-id');
          });

          similarVendors.forEach((similarVendor) => {
            const vendorRow = similarVendor.closest('tr.data-table__tr');
            const mergeCheckbox = vendorRow.querySelector(mergeCheckboxesSelector);

            if (!mergeCheckbox.checked) {
              duplicatedFlag.dataset.selectedGroupId = uuid;
              mergeCheckbox.dataset.selectedGroupId = uuid;
              vendorRow.querySelector('.status-badge--duplicated').dataset.selectedGroupId = uuid;
              mergeCheckbox.checked = true;
              mergeCheckbox.dispatchEvent(new Event('change', { bubbles: true }));
            }

            if (mergeCheckbox.checked && mergeCheckbox.dataset.selectedGroupId === undefined) {
              mergeCheckbox.dataset.selectedGroupId = uuid;
            }
          });

          setVendorIdsToMergeParam(similarIds, currentParams, currentUrl);
        }
      });
    });

    document.querySelectorAll(mergeCheckboxesSelector).forEach((checkbox) => {
      checkbox.addEventListener('change', () => {
        const vendorId = checkbox.dataset.vendorId;
        const currentUrl = new URL(window.location);
        const currentParams = currentUrl.searchParams;
        let currentVendorIds = currentParams.getAll('vendor_ids_to_merge[]');

        if (checkbox.checked) {
          currentVendorIds.push(vendorId);
        } else {
          const vendorRow = checkbox.closest('tr');

          checkbox.removeAttribute('data-selected-group-id');
          const duplicatedFlag = vendorRow.querySelector('.status-badge--duplicated');
          if (duplicatedFlag) {
            duplicatedFlag.removeAttribute('data-selected-group-id');
          }

          currentVendorIds = currentVendorIds.filter((id) => id !== vendorId);
        }

        setVendorIdsToMergeParam(currentVendorIds, currentParams, currentUrl);
      });
    });

    updateMergeCounter();
  }
});
